export class EstimatedProcedure{
    code: string = '';
    description: string = '';
    priority: number = 0;
    billAmount: number = 0;
    reimbursement: number = 0;                  // TOTAL (calculated)
    procedureReimbursement: number = 0;         // User enters
    implantReimbursement: number = 0;           // User enters
    implantCost: number = 0;
    selfPay: boolean = false;
    isAuthRequired: boolean = false;

    constructor(code:string, description: string){
        this.code = code;
        this.description = description;
    }

}